import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import ErrorMessage from './ErrorMessage'
import { formMessage } from './Message'
import StepQuestion from './StepQuestion'
import Image from '../../../function/Image'

const StepOne = ({ question, name, options, image, description }) => {
    const {
        formState: { errors }
    } = useFormContext()
    const errorMessage = errors?.[name]?.message

    return (
        <fieldset className="flex flex-col-reverse items-start justify-between lg:flex-row">
            <div className="max-w-[630px]">
                <legend className="font-grotesk-bold text-3xl leading-snug lg:text-[30px]">
                    {question&&<span>{question}</span>}
                </legend>
                <ErrorMessage message={errorMessage} />

                <div className="mt-10 space-y-3">
                    {options?.map((option, index) => {
                        return (
                            <Radio
                                value={option}
                                id={name + index}
                                name={name}
                            />
                        )
                    })}
                </div>
            </div>
            <div className="mb-6 flex max-w-[550px] flex-col items-center justify-center rounded-xl bg-[#F2F4F7] px-12 py-12 lg:mb-0">
                {image && <Image {...image} className="w-[286px]" />}
                {description && (
                    <p className="mt-7 text-center font-grotesk-light text-xl text-black">
                        {description}
                    </p>
                )}
            </div>
        </fieldset>
    )
}

const Radio = ({ value, id, name, checked }) => {
    const { register } = useFormContext()
    return (
        <div className="group !mb-6">
            <input
                checked={checked}
                {...register(name, { required: formMessage.required })}
                id={id}
                className="sr-only"
                value={value}
                type="radio"
            />
            <label
                className="relative flex w-fit cursor-pointer items-center justify-center pl-11"
                htmlFor={id}
            >
                <span className="ml-3 font-grotesk-light text-xl leading-6 lg:pt-2">
                    {value}
                </span>
                <span className="group absolute left-0 top-2 aspect-square w-5 translate-x-1 rounded-full bg-transparent outline outline-2 outline-offset-4 outline-vivid_raspberry group-has-[input:checked]:bg-vivid_raspberry lg:w-[26px] lg:outline-[4px]"></span>
            </label>
        </div>
    )
}

export default StepOne
